"use client";

import { createContext, use } from "react";

type StepContextValue = {
  isActive: boolean;
};

const StepContext = createContext<StepContextValue>({ isActive: false });

function useStep(): StepContextValue {
  return use(StepContext);
}

export { StepContext, useStep };
